<template>
  <div class="right-container" @click.stop="toggleDrawerRightMenu">
    <el-tooltip
      v-model="tooltipAttributes.value"
      :disabled="tooltipAttributes.disabled"
      placement="bottom"
      effect="light"
      manual
    >
      <div slot="content">
        <i
          v-if="tooltipAttributes.icon==='success'"
          class="el-icon-success"
          style="font-size: 15px;vertical-align: bottom;color:#67C23A;"
        />
        <i
          v-else
          class="el-icon-info"
          style="font-size: 15px;vertical-align: bottom;"
        />
        {{ tooltipAttributes.content }}
      </div>
      <div style="width:100%;height:100%;">
        <i class="el-icon-collection" style="font-size:15px;top:8px" />
      </div>
    </el-tooltip>

    <el-drawer
      title="APK包上传窗口任务"
      :visible.sync="drawerRightMenu"
      direction="rtl"
      :show-close="false"
      custom-class="drawer-right-menu"
      :append-to-body="true"
      :size="$global.isPC ? '40%' : '60%'"
      :before-close="toggleDrawerRightMenu"
    >
      <el-alert type="info" :closable="false">
        <div slot="title" style="font-size: 14px;">
          <i class="el-icon-info" style="margin-right: 4px;" />温馨提示：
        </div>
        <div class="alert_tips">
          <ul>
            <li>下面表格显示的是 “ 游戏关系 ” → “ 子游戏 ”  →  “ 操作 ”中 “ 上传APK包 ” 的最小化窗口。</li>
            <li>本功能最大空间为5个队列，采用循环使用方式。若超出队列最大限制，将自动删除第一位。</li>
          </ul>
        </div>
      </el-alert>
      <el-table
        :data="miniDialogAPK"
        borderc
        :max-height="500"
        highlight-current-row
        :header-cell-style="{background:'#f8f8f9'}"
        :row-class-name="tableRowClassName"
        style="margin-top: 8px; width: 100%"
      >
        <el-table-column
          align="center"
          label="序号"
          width="50"
        >
          <template slot-scope="scope">
            {{ scope.$index+ 1 }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="当前步骤"
          width="130"
        >
          <template slot-scope="scope">
            {{ scope.row.instance.activeStep===0? '校验SDK':'SDK接入检测' }}
            <el-tooltip
              v-if="scope.row.instance.errorMsg"
              effect="dark"
              :content="scope.row.instance.errorMsg"
              placement="top-start"
            >
              <i
                class="el-icon-error"
                style="margin-left: 4px; font-size: 14px;color:#F56C6C;cursor: pointer;"
              />
            </el-tooltip>

            <i
              v-else-if="scope.row.instance.loading "
              class="el-icon-loading"
              style="margin-left: 4px; font-size: 14px;color:#409EFF"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="平台"
        >
          <template slot-scope="scope">
            {{ $global.platformMap[scope.row.instance.row.platform] }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="游戏ID"
        >
          <template slot-scope="scope">
            {{ scope.row.instance.row.game_id }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="融合方式"
          width="90"
        >
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.instance.componentsBase.grInGameUploadApkForm.apk.mix_type"
              :type="toFilterMixType(scope.row.instance.componentsBase.grInGameUploadApkForm)==='错误类型'?'danger':'success'"
              :underline="false"
            >
              {{ toFilterMixType(scope.row.instance.componentsBase.grInGameUploadApkForm) }}
            </el-link>
            <el-link v-else type="info" :underline="false">空</el-link>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="媒体类型"
          width="90"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.instance.componentsBase.grInGameUploadApkForm.apk.mix_type==='CUSTOM_MIX'"
              type="success"
              :underline="false"
            >
              {{ toFilterMediaType(scope.row.instance.componentsBase.grInGameUploadApkForm) }}
            </el-link>
            <el-link v-else type="info" :underline="false"> / </el-link>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="APK文件源名称"
          width="110"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.instance.componentsBase.grInGameUploadApkForm.fileList.length>0"
              type="success"
              :underline="false"
            >
              {{ scope.row.instance.componentsBase.grInGameUploadApkForm.fileList[0].name }}
            </el-link>
            <el-link v-else type="info" :underline="false">空</el-link>

          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="操作"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-copy-document"
              @click="handleToOpenGrInGameUploadApk(scope.row)"
            >打开</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RightSDKWinTask',
  data() {
    return {
      drawerRightMenu: false,
      mix_type: {
        'CUSTOM_MIX': '自定义融合',
        'SYSTEM_MIX': '系统融合'
      },
      tooltipAttributes: {
        value: false,
        disabled: false,
        content: '嘿~ 你把我放到这里了哦！'
      }
    }
  },
  computed: {
    ...mapGetters([
      'miniDialogAPK'
    ])
  },
  watch: {
    '$store.getters.miniDialogAPK'(newTaskList) {

    },
    '$store.getters.tooltipAttributes': {
      handler(newVal) {
        this.tooltipAttributes = newVal
      },
      deep: true
    }
  },
  methods: {
    /**
     * 切换是否打开抽屉
     */
    toggleDrawerRightMenu() {
      this.drawerRightMenu = !this.drawerRightMenu
    },
    /**
     * 打开最小化的上传窗口
     */
    handleToOpenGrInGameUploadApk(row) {
      this.drawerRightMenu = false
      setTimeout(() => {
        row.instance.isVisible = true
      }, 350)
    },
    toFilterMediaType(instance) {
      const mediaType = instance.opt.mediatype.filter(item => item.value === instance.apk.media_type)
      return mediaType.length > 0 ? mediaType[0]['label'] : '未知'
    },
    toFilterMixType(instance) {
      const mixType = {
        'CUSTOM_MIX': '自定义融合',
        'SYSTEM_MIX': '系统融合'
      }

      return mixType[instance.apk.mix_type] || '错误类型'
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.instance.errorMsg !== '') {
        return 'error-row'
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.right-container{
  float: left;
  line-height: 40px;
  width: 40px;
  text-align: center;
  height: 48px;
  cursor: pointer;
  i{
    position: relative;
    top: 6px;
  }
}
.right-container:hover{
  background: #F5F7FA;
}
</style>
<style lang="scss">
.drawer-right-menu {
  .alert_tips {
    ul {
      margin: 0 0 0 34px;
      padding: 0;
      list-style: auto;
      li {
        padding: 4px 0;
        line-height: 1.5;
      }
    }
  }
  .el-table .error-row {
    background: #fde2e2;
  }
}
</style>
